import classNames from 'classnames';

import ArrowDownIcon from '@/assets/icons/arrow-down.svg?react';
import Input from '@/components/ui/forms/Input';

import styles from './DatePickerInput.module.scss';

interface Props extends React.ComponentProps<typeof Input> {
  isOpen?: boolean;
}

const DatePickerInput: React.FC<Props> = ({ isOpen, ...props }) => (
  <div className={styles.wrapper} data-is-open={isOpen}>
    <Input
      type="text"
      {...props}
      readOnly
      className={classNames(styles.input, props.className)}
    />
    <i className={styles.icon} onClick={props.onClick}>
      <ArrowDownIcon className={styles.arrow} />
    </i>
  </div>
);

export default DatePickerInput;
